import { Decimal } from 'decimal.js';

export const INVALID_PRICE = -1;

export function isValidPrice(price) {
  return Number(price) > 0;
}

export function requireValidPrice(price, defaultPrice = 0) {
  return isValidPrice(price) ? price : defaultPrice;
}

export function truncateWithoutRounding({
  amount,
  precision,
  returnDisplayString = false,
}) {
  if (!amount) return '';
  const amountString = amount.toString();
  const [integers, decimals] = amountString.split('.');

  // Format integers with commas if returnDisplayString is true
  let formattedIntegers = integers;
  if (returnDisplayString) {
    const num = parseInt(integers);
    if (num >= 1e12) {
      // Trillion
      const trillions = (num / 1e12).toFixed(0);
      formattedIntegers = `${trillions.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}T`;
    } else {
      formattedIntegers = integers.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }
  if (decimals) {
    const truncatedDecimals =
      decimals.length > precision ? decimals.substring(0, precision) : decimals;
    return `${formattedIntegers}.${truncatedDecimals}`;
  } else {
    return `${formattedIntegers}`;
  }
}

export function toCrypto({ conversion, amount, precision }) {
  if (!isValidPrice(conversion)) return 0;
  return Decimal.div(amount, conversion).toFixed(precision);
}

export function toFiat({ conversion, amount, precision }) {
  if (!isValidPrice(conversion)) return 0;
  return Decimal.mul(amount, conversion).toFixed(precision);
}

export function getCryptoSendError({ coin, feeCoin, amount, gas, isCore }) {
  let error = false;
  let message = '';

  if (coin?.useEthGas) {
    const feeCoinLow = Decimal(feeCoin?.coinAmt).lessThan(gas);
    if (feeCoinLow) {
      message = `This coin requires ${
        feeCoin?.cryptoAsset?.display.symbol || 'the fee asset'
      } to pay the gas fee. You don't have enough ${
        feeCoin?.cryptoAsset?.display.symbol || 'the fee asset'
      } in your wallet ${isCore ? '2.0' : '1.0'}`;
      error = true;
    }
    const amountHigh = Decimal(amount).greaterThan(coin.coinAmt);
    if (amountHigh) {
      message = 'The amount you are trying to transfer is larger than your balance.';
      error = true;
    }
    const amountLow = Decimal(amount).lessThanOrEqualTo(0);
    if (amountLow) {
      message = 'Your balance is insufficient to make a transfer.';
      error = true;
    }
  } else {
    const amountHigh = Decimal.add(amount, gas).greaterThan(coin.coinAmt);
    if (amountHigh) {
      message = 'Amount entered exceeds available balance with gas fee.';
      error = true;
    }
    const amountLow = Decimal(amount).lessThanOrEqualTo(0);
    if (amountLow) {
      message = 'Your transfer amount needs to be greater than 0.';
      error = true;
    }
  }
  return { error, message };
}

export function getCryptoAddressError({ coin, address, validateAddress }) {
  let error = false;
  let message = '';

  if (!validateAddress) {
    throw new Error('validateAddress is required');
  }

  if (address === coin.walletId) {
    error = true;
    message = 'You cannot send funds to yourself.';
  } else {
    const isValidAddress = validateAddress(address);
    if (!isValidAddress) {
      error = true;
      message = 'Incorrect wallet address format, please try again';
    }
  }

  return { error, message };
}
